import GeistProvider from './geist-provider';
export default GeistProvider;